import {HiChevronDoubleLeft, HiChevronDoubleRight} from "react-icons/hi";

export const Paginacao = ({pagina, setPagina, info}) => {
  let max = info.total_paginas;
  const Botoes = () => {
    let botoes = [];
    if (pagina <= 0) {
      setPagina(1);
    }
    if (max !== 1) {
      if (pagina === 1 || pagina === 2){
        if (pagina === 1) {
          botoes.push(
            <div
              key={1}
              className="btn-paginacao ativo"
            >
              1
            </div>
          );
          for (let i = 2; i <= (max > 5 ? 5 : max); i++) {
            botoes.push(
              <div
                key={i}
                className="btn-paginacao"
                onClick={() => setPagina(i)}
              >
                {i}
              </div>
            );
          }
        } else {
          botoes.push(
            <div
              key={0}
              className="btn-paginacao"
              onClick={() => setPagina(pagina-1)}
            >
              <HiChevronDoubleLeft/>
            </div>
          );
          botoes.push(
            <div
              key={1}
              className="btn-paginacao"
              onClick={() => setPagina(1)}
            >
              {1}
            </div>
          );
          botoes.push(
            <div
              key={2}
              className="btn-paginacao ativo"
            >
              {2}
            </div>
          );
          for (let i = 3; i <= (max > 5 ? 5 : max); i++) {
            botoes.push(
              <div
                key={i}
                className="btn-paginacao"
                onClick={() => setPagina(i)}
              >
                {i}
              </div>
            );
          }
        }
      } else {
        if (pagina === max || pagina === (max - 1)) {
          if (pagina === max) {
            botoes.push(
              <div
                key={0}
                className="btn-paginacao"
                onClick={() => setPagina(pagina-1)}
              >
                <HiChevronDoubleLeft/>
              </div>
            );
            for (let i = (max > 4 ? (max - 4) : 1); i <= (max - 1); i++) {
              botoes.push(
                <div
                  key={i}
                  className="btn-paginacao"
                  onClick={() => setPagina(i)}
                >
                  {i}
                </div>
              );
            }
            botoes.push(
              <div
                key={max}
                className="btn-paginacao ativo"
              >
                {max}
              </div>
            );
          } else {
            botoes.push(
              <div
                key={0}
                className="btn-paginacao"
                onClick={() => setPagina(pagina-1)}
              >
                <HiChevronDoubleLeft/>
              </div>
            );
            for (let i = (max > 3 ? (max - 4) : 1); i <= (max - 2); i++) {
              botoes.push(
                <div
                  key={i}
                  className="btn-paginacao"
                  onClick={() => setPagina(i)}
                >
                  {i}
                </div>
              );
            }
            botoes.push(
              <div
                key={max-1}
                className="btn-paginacao ativo"
              >
                {max-1}
              </div>
            );
            botoes.push(
              <div
                key={max}
                className="btn-paginacao"
                onClick={() => setPagina(max)}
              >
                {max}
              </div>
            );
          }
        } else {
          botoes.push(
            <div
              key={0}
              className="btn-paginacao"
              onClick={() => setPagina(pagina-1)}
            >
              <HiChevronDoubleLeft/>
            </div>
          );
          for (let i = (pagina - 2); i < pagina; i++) {
            botoes.push(
              <div
                key={i}
                className="btn-paginacao"
                onClick={() => setPagina(i)}
              >
                {i}
              </div>
            );
          }
          botoes.push(
            <div
              key={pagina}
              className="btn-paginacao ativo"
            >
              {pagina}
            </div>
          );
          for (let i = (pagina + 1); i <= (pagina + 2); i++) {
            botoes.push(
              <div
                key={i}
                className="btn-paginacao"
                onClick={() => setPagina(i)}
              >
                {i}
              </div>
            );
          }
        }
      }
    }

    if (pagina !== max) {
      botoes.push(
        <div
          key="proxima"
          className="btn-paginacao"
          onClick={() => setPagina(pagina+1)}
        >
          <HiChevronDoubleRight/>
        </div>
      );
    }

    return (
      botoes.map((item) => (item))
    );
  }
  return (
    <div className="paginacao">
      <div className="paginacao-info">
        Exibindo {(pagina*10)-9}-{((pagina*10) > (info.total_registros)) ? (info.total_registros) : (pagina*10)} de {info.total_registros} itens
      </div>
      <div className="paginas">
        <Botoes/>
      </div>
    </div>
  );
}